import Home from 'components/core/Home';
import AgendaMedica from 'pages/agenda/AgendaMedica';
import ReportAtestado from 'pages/atestado/ReportAtestado';
import FormAtividades from 'pages/atividade/FormAtividades';
import SignInMed from 'pages/doctor/SignInMed';
import FormFuncionario from 'pages/funcionario/FormFuncionario';
import PerfilFunc from 'pages/funcionario/PerfilFunc';
import SignInFunc from 'pages/funcionario/SignInFunc';
import FormCarotida from 'pages/laudo/carotida/FormCarotida';
import ReportCarotida from 'pages/laudo/carotida/ReportCarotida';
import FormEcg from 'pages/laudo/ecg/FormEcg';
import ReportEcg from 'pages/laudo/ecg/ReportEcg';
import FormEcocongenito from 'pages/laudo/ecocongenito/FormEcocongenito';
import ReportEcocongenito from 'pages/laudo/ecocongenito/ReportEcocongenito';
import FormEcodoppler from 'pages/laudo/ecodoppler/FormEcodoppler';
import ReportEcodoppler from 'pages/laudo/ecodoppler/ReportEcodoppler';
import FormErgo from 'pages/laudo/ergo/FormErgo';
import ReportErgo from 'pages/laudo/ergo/ReportErgo';
import Fetal from 'pages/laudo/fetal/Fetal';
import Prontuario from 'pages/laudo/prontuario/Prontuario';
import FormStress from 'pages/laudo/stress/FormStress';
import ReportStress from 'pages/laudo/stress/ReportStress';
import FormTiltTest from 'pages/laudo/tilt/FormTiltTest';
import ReportTiltTest from 'pages/laudo/tilt/ReportTiltTest';
import FormTrans from 'pages/laudo/trans/FormTrans';
import ReportTrans from 'pages/laudo/trans/ReportTrans';
import AgendamentoOnlineFlow from 'pages/paciente/AgendamentoOnlineFlow';
import AgendaPaciente from 'pages/paciente/AgendaPaciente';
import Laudos from 'pages/paciente/Atividade';
import DashboardPac from 'pages/paciente/Dashboard';
import FormPaciente from 'pages/paciente/FormPaciente';
import ReceitasPaciente from 'pages/paciente/Receitas';
import SignInPac from 'pages/paciente/SignInPac';
import SignUpPac from 'pages/paciente/SignUpPac';
import PainelDeChamadas from 'pages/painel/PainelDeChamadas';
import FormReceitas from 'pages/receita/FormReceitas';
import ReportReceita from 'pages/receita/ReportReceita';
import Validacao from 'pages/receita/Validacao';
import ReportRequisicao from 'pages/requisicao/ReportRequisicao';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  selectDoctor,
  selectFunc,
  selectPatient,
  signOutDoctor,
  signOutFunc,
  signOutPatient,
} from 'redux/features/auth/authSlice';
import Route from './routes';

// TODO: como melhorar essas rotas?
// TODO: Code splitting. Pra que carregar tudo pro paciente, por exemplo, sendo que nem precisa? Testar em diferentes devices e networks.
export default function Routes() {
  const dispatch = useDispatch();
  const patient = useSelector(selectPatient);
  const doctor = useSelector(selectDoctor);
  const func = useSelector(selectFunc);

  // TODO: isso aqui é melhor usar jwt session (e invalidate token/end session/refresh) do que useIdleTimer
  function onIdle() {
    if (doctor) {
      toast.success('Médico desconectado!');
      dispatch(signOutDoctor());
    }
    if (patient) {
      toast.success('Paciente desconectado!');
      dispatch(signOutPatient());
    }
    if (func) {
      toast.success('Funcionário desconectado!');
      dispatch(signOutFunc());
    }
  }

  // 10 min para paciente, 60 min para funcionário, nenhum timeout para médico
  let idleTimeout = null;
  if (patient) {
    idleTimeout = 1000 * 60 * 10; // 10 min
  } else if (func) {
    idleTimeout = 1000 * 60 * 60; // 60 min
  }

  useIdleTimer(
    idleTimeout
      ? {
          timeout: idleTimeout,
          onIdle,
          debounce: 250,
        }
      : { timeout: 1, onIdle: undefined, debounce: 250 }
  );

  return (
    <Switch>
      {/* Rotas públicas */}
      <Route path="/" exact component={Home} />
      <Route path="/medico/login" component={SignInMed} />
      <Route path="/funcionario/login" component={SignInFunc} />
      <Route path="/paciente/login" component={SignInPac} />
      <Route path="/paciente/cadastro" component={SignUpPac} />
      <Route path="/receita/validacao" component={Validacao} allowAuthenticatedPublic />
      <Route path="/atestado/validacao" component={Validacao} allowAuthenticatedPublic />
      <Route path="/requisicao/validacao" component={Validacao} allowAuthenticatedPublic />
      <Route path="/validacao/:tipo?" component={Validacao} allowAuthenticatedPublic />
      {/*  <Route path="/paciente/agendamento-online" component={AgendamentoOnlineFlow} /> */}

      {/* Rotas de DOCTOR e FUNCIONARIO */}
      <Route
        path="/agenda"
        component={AgendaMedica}
        isPrivate
        requiredRole={['doctor', 'funcionario']}
      />
      <Route path="/painel" component={PainelDeChamadas} disableLayout />

      <Route
        path="/atividades" // TODO; TA ERRADO. PRECISO MUDAR ISSO
        component={FormAtividades}
        isPrivate
        requiredRole={['doctor', 'funcionario']}
      />
      <Route
        path="/pacientes"
        component={FormPaciente}
        isPrivate
        requiredRole={['doctor', 'funcionario']}
      />

      {/* ECG por IA desativado — não usado hoje.
      {doctor && doctor.codMed === 7 && (
        <Route path="/formEcgIA" component={EcgPage} isPrivate requiredRole="doctor" />
      )}
      */}

      {/* Rotas compartilhadas (doctor ou patient ou funcionario) */}
      <Route path="/visualizacao-ecg/:id" component={ReportEcg} isPrivate />
      <Route path="/formulario-ecg/:id" component={FormEcg} isPrivate />
      <Route path="/receitas" component={FormReceitas} isPrivate />
      <Route path="/paciente/receitas" component={ReceitasPaciente} isPrivate />
      <Route path="/prontuario/:codpac" component={Prontuario} isPrivate />
      <Route path="/visualizacao-trans/:id" component={ReportTrans} isPrivate />
      <Route path="/formulario-trans/:id" component={FormTrans} isPrivate />
      <Route path="/visualizacao-carotida/:id" component={ReportCarotida} isPrivate />
      <Route path="/formulario-carotida/:id" component={FormCarotida} isPrivate />
      <Route path="/visualizacao-ecodoppler/:id" component={ReportEcodoppler} isPrivate />
      <Route path="/formulario-ecodoppler/:id" component={FormEcodoppler} isPrivate />
      <Route path="/formulario-ecocongenito/:id" component={FormEcocongenito} isPrivate />
      <Route path="/visualizacao-ecocongenito/:id" component={ReportEcocongenito} isPrivate />
      <Route path="/formulario-stress/:id" component={FormStress} isPrivate />
      <Route path="/visualizacao-stress/:id" component={ReportStress} isPrivate />
      <Route path="/reportFetal" component={Fetal} isPrivate />
      <Route path="/visualizacao-ergo/:id" component={ReportErgo} isPrivate />
      <Route path="/formulario-ergo/:id" component={FormErgo} isPrivate />
      <Route path="/visualizacao-tilt/:id" component={ReportTiltTest} isPrivate />
      <Route path="/formulario-tilt/:id" component={FormTiltTest} isPrivate />
      <Route path="/imprimir/receita" component={ReportReceita} isPrivate />
      <Route path="/imprimir/requisicao" component={ReportRequisicao} isPrivate />
      <Route path="/imprimir/atestado" component={ReportAtestado} isPrivate />

      {/* Rotas de FUNCIONARIO */}
      <Route
        path="/perfil-funcionario"
        component={PerfilFunc}
        isPrivate
        requiredRole="funcionario"
      />
      <Route
        path="/formulario-funcionario"
        component={FormFuncionario}
        isPrivate
        requiredRole="funcionario"
      />

      {/* Rotas de PATIENT */}
      <Route path="/dashboardpac" component={DashboardPac} isPrivate requiredRole="patient" />
      <Route path="/paciente/agenda" component={AgendaPaciente} isPrivate requiredRole="patient" />
      <Route path="/frmatvpac" component={Laudos} isPrivate requiredRole="patient" />
      {patient ? (
        <>
          <Route
            path="/paciente/agendamento-online"
            component={AgendamentoOnlineFlow}
            isPrivate
            requiredRole="patient"
          />
        </>
      ) : (
        <>
          <Route path="/paciente/agendamento-online" component={AgendamentoOnlineFlow} />
        </>
      )}
    </Switch>
  );
}
